import styled from 'styled-components';

export const FloatingScroll = styled.div`
  position: absolute;
  transform: rotate(-90deg);
  transform-origin: center;
  right: -80px;
  left: auto;
  z-index: 9;
  top: 50%;

  p {
    position: relative;
    font-size: 12px;
    letter-spacing: 2.9px;
    margin: 0;
    color: ${({ theme: { colors }, dark }) =>
      dark ? colors.black : colors.white};

    i {
      font-size: 30px;
      vertical-align: middle;
      position: relative;
      top: 0px;
      animation-name: scrollArrows;
      animation-duration: 1.5s;
      animation-iteration-count: infinite;
      animation-fill-mode: forwards;

      &:first-child {
        animation-delay: 0.75s;
      }

      &:nth-child(2) {
        animation-delay: 0.5s;
      }

      &:last-child {
        animation-delay: 0.25s;
      }
    }
  }

  @keyframes scrollArrows {
    from {
      opacity: 1;
    }

    to {
      opacity: 0.5;
    }
  }
`;
